import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, Link } from 'react-router-dom';
import SiteHeader from '@/components/SiteHeader';
import SiteFooter from '@/components/SiteFooter';
import CartDrawer from '@/components/CartDrawer';
import { FileText, Loader2 } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const LegalPage = () => {
  const { slug } = useParams();
  const [cartOpen, setCartOpen] = useState(false);
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setLoading(true);
    setNotFound(false);
    axios.get(`${API}/pages/${slug}`)
      .then(({ data }) => setPage(data))
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, [slug]);

  return (
    <div className="min-h-screen flex flex-col bg-[#09090B] text-white">
      <SiteHeader onCartClick={() => setCartOpen(true)} />

      <main className="flex-1 max-w-3xl mx-auto w-full px-6 lg:px-10 py-16">
        <div className="text-center mb-10">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-[#00F0FF]/10 border border-[#00F0FF]/30 mb-4">
            <FileText className="text-[#00F0FF]" size={20} />
          </div>
          <h1 className="text-3xl md:text-4xl font-heading font-medium tracking-tight" data-testid="legal-title">
            {loading ? 'Loading...' : (page?.title || 'Page not found')}
          </h1>
        </div>

        <div className="bg-[#121214] border border-[#27272A] rounded-lg p-8 md:p-10">
          {loading ? (
            <div className="flex items-center justify-center py-8">
              <Loader2 className="text-[#00F0FF] animate-spin" size={28} />
            </div>
          ) : notFound ? (
            <p className="text-[#A1A1AA] text-center">
              This page does not exist. <Link to="/" className="text-[#00F0FF] hover:underline">Back home</Link>
            </p>
          ) : (
            <>
              <article
                className="text-[#A1A1AA] leading-relaxed whitespace-pre-wrap text-[15px]"
                data-testid="legal-body"
              >
                {page?.body}
              </article>
              <p className="text-xs text-[#A1A1AA] italic mt-8 pt-4 border-t border-[#27272A]">
                Last updated: {page?.updated_at ? new Date(page.updated_at).toLocaleDateString() : '—'}
              </p>
            </>
          )}
        </div>
      </main>

      <SiteFooter />
      <CartDrawer open={cartOpen} onClose={() => setCartOpen(false)} />
    </div>
  );
};

export default LegalPage;
